import React from 'react';
import BootstrapModal from 'react-bootstrap/lib/Modal';
import PropTypes from 'prop-types';
import CloseSvg from '../../components/svgs/Close';
import styles from './Modal.sass';
import If, { isIfComponent, isIfComponentNull } from '../If';
import Icon from '../Icon';
import Pressable from '../Pressable';
import Hoverable from '../Hoverable';
import Box from '../Box';

const renderNoop = () => null;
const noop = () => null;

const Modal = ({
  isShowing,
  isShowingCloseButton,
  onClickOutside,
  onClickClose,
  renderContent,
  className,
  contentClassName,
  dialogClassName,
  renderOverlayContent,
  closeIconColor,
  useBaseContentClass,
}) => {
  // Note: If our renderOverlayContent function uses the <If> component
  //       as a top-level component, we need to determine if it returns
  //       a react element of not. This is because the <If> component will
  //       always return a react element. We need to do some extra checking
  //       to see if the If component is rendering anything.
  const shouldRenderOverlay = isIfComponent(renderOverlayContent())
    ? !isIfComponentNull(renderOverlayContent())
    : renderOverlayContent();
  return (
    <BootstrapModal
      show={isShowing}
      onHide={onClickOutside}
      bsClass={styles.root}
      dialogClassName={`${styles.dialog} ${dialogClassName}`}
      className={className}
    >
      <If
        condition={isShowingCloseButton}
        ifRender={() => (
          <Box
            marginTop={16}
            marginLeft={14}
            width={18}
            height={18}
            position="absolute"
            top
            left
            dangerouslySetInlineStyle={{ zIndex: 20 }}
          >
            <Hoverable fullWidth>
              {({ isHovering }) => (
                <Pressable
                  onPress={onClickClose}
                  fullWidth
                  isEventBubblingAllowed={false}
                >
                  {({ isPressed }) => (
                    <Icon
                      type="x"
                      fillColor={isHovering ? '#7F8287' : closeIconColor}
                    />
                  )}
                </Pressable>
              )}
            </Hoverable>
          </Box>
        )}
      />
      <div
        className={
          useBaseContentClass
            ? `${styles.content} ${contentClassName}`
            : contentClassName
        }
      >
        {renderContent()}
      </div>
      <If
        condition={shouldRenderOverlay}
        ifRender={() => (
          <Box
            testId="splitModal-exit-confirmation-container"
            position="absolute"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            top
            left
            width="100%"
            height="100%"
            color="rgba(255,255,255,0.96)"
            className={styles.overlay}
            dangerouslySetInlineStyle={{
              zIndex: 9999999999,
            }}
          >
            {renderOverlayContent()}
          </Box>
        )}
      />
    </BootstrapModal>
  );
};

Modal.defaultProps = {
  isShowingCloseButton: false,
  onClickOutside: noop,
  onClickClose: noop,
  renderContent: renderNoop,
  contentClassName: '',
  dialogClassName: '',
  className: '',
  renderOverlayContent: noop,
  closeIconColor: '#C9CBCD',
  useBaseContentClass: true,
};

Modal.propTypes = {
  renderOverlayContent: PropTypes.func,
  isShowing: PropTypes.bool.isRequired,
  isShowingCloseButton: PropTypes.bool,
  onClickClose: PropTypes.func,
  onClickOutside: PropTypes.func,
  renderContent: PropTypes.func,
  contentClassName: PropTypes.string,
  dialogClassName: PropTypes.string,
  className: PropTypes.string,
  closeIconColor: PropTypes.string,
  useBaseContentClass: PropTypes.bool,
};

export { Modal as default, Modal };
